import React from "react";
import { ArrowTopRightOnSquareIcon } from "@heroicons/react/24/outline";

/**
 * Persistent announcement banner for the Open Org integration.
 * Renders at the top of the Hero on the landing page.
 */
export default function OpenOrgAnnouncementBanner() {
  return (
    <div
      className="mb-10 sm:mb-12 flex flex-wrap items-center justify-center gap-x-3 gap-y-2"
      role="banner"
      aria-label="Product announcement"
    >
      <div className="inline-flex flex-wrap items-center justify-center gap-x-3 gap-y-2 rounded-full border border-indigo-200 bg-indigo-50/90 px-5 py-3 backdrop-blur-sm ring-1 ring-indigo-100 shadow-sm">
        <p className="text-sm sm:text-base text-gray-700">
          <span className="font-medium text-indigo-700">In June 2026,</span>
          <span className="mx-1.5 font-semibold text-gray-900">peoplemetrics.fyi</span>
          <span className="mx-1">joins</span>
          <span className="font-semibold text-indigo-700">Open Org&apos;s Workspace</span>
        </p>
        <a
          href="https://openorg.fyi"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-1 rounded-full bg-indigo-100 px-3 py-1.5 text-sm font-medium text-indigo-700 hover:bg-indigo-200/80 transition-colors"
        >
          <span>Learn more</span>
          <ArrowTopRightOnSquareIcon className="h-3.5 w-3.5" />
        </a>
      </div>
    </div>
  );
}
